<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <div class="vx-row">
                    <h3 class="ml-2">{{ this.$t('workShiftByDay.settingShiftByDay') }}</h3>
                </div>
                <!-- Content Row -->
                <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <vs-input class="w-full" :label="this.$t('workShiftByDay.employeeCode')" :disabled="true"
                                  v-model="employeeInfo.employeeCode"
                                  v-validate="'required'" name="employeeCode"/>
                        <span class="text-danger text-sm">{{ errors.first('employeeCode') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <vs-input class="w-full" :label="this.$t('workShiftByDay.name')" :disabled="true"
                                  v-model="employeeInfo.fullName"
                                  v-validate="'required'" name="fullName"/>
                        <span class="text-danger text-sm">{{ errors.first('fullName') }}</span>
                    </div>
                </div>


                <div class="vx-row no-scroll-content mt-6">
                    <calendar-view
                        ref="calendar"
                        locale="vn"
                        :displayPeriodUom="calendarView"
                        :events="events"
                        eventContentHeight="1.65rem"
                        class="theme-default"
                        @click-date="openAddNewEvent"
                        @click-event="openEditEvent">

                        <div slot="header" class="mb-4">

                            <div class="vx-row no-gutter">

                                <!-- Month Name -->
                                <div class="vx-col w-1/3 items-center sm:flex hidden">
                                    <!-- Add new event button -->
                                </div>

                                <!-- Current Month -->
                                <div
                                    class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
                                    <div class="flex items-center">
                                        <feather-icon
                                            :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                                            @click="updateMonth(-1)"
                                            svgClasses="w-5 h-5 m-1"
                                            class="cursor-pointer bg-primary text-white rounded-full"/>

                                        <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{
                                                showDateString
                                            }}</span>

                                        <feather-icon
                                            :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                                            @click="updateMonth(1)"
                                            svgClasses="w-5 h-5 m-1"
                                            class="cursor-pointer bg-primary text-white rounded-full"/>
                                    </div>
                                </div>

                                <div class="vx-col sm:w-1/3 w-full flex justify-center">
                                    <template v-for="(view, index) in calendarViewTypes">
                                        <vs-button
                                            v-if="calendarView === view.val"
                                            :key="String(view.val) + 'filled'"
                                            type="filled"
                                            class="p-3 md:px-8 md:py-3"
                                            :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                            @click="calendarView = view.val"
                                        >{{ view.label }}
                                        </vs-button>
                                        <vs-button
                                            v-else
                                            :key="String(view.val) + 'border'"
                                            type="border"
                                            class="p-3 md:px-8 md:py-3"
                                            :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                                            @click="calendarView = view.val"
                                        >{{ view.label }}
                                        </vs-button>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </calendar-view>
                </div>


                <!--CREATE EVENT-->
                <vs-prompt
                    class="calendar-event-dialog"
                    :title="this.$t('workShiftByDay.addShift')"
                    :accept-text="this.$t('button.add')"
                    :cancel-text="this.$t('button.close')"
                    @accept="addEvent"
                    :is-valid="validForm"
                    :active.sync="activePromptAddEvent">


                    <div class="content-popup">

                        <div class="my-8">
                            <small class="date-label required">{{ $t('workShiftByDay.groupShift') }}</small>
                            <vs-input name="group-name" v-validate="'required'" :maxlength="50" class="w-full"
                                      v-model="groupName"></vs-input>
                        </div>
                        <div class="my-8">
                            <small class="date-label required">{{ $t('workShiftByDay.nameShift') }}</small>
                            <vs-input name="work-shift-name" v-validate="'required'" :maxlength="50" class="w-full"
                                      v-model="workShiftName"></vs-input>
                        </div>
                        <div class="my-8">
                            <small class="date-label required">{{ this.$t('workShiftByDay.workDay') }}</small>
                            <datepicker :format="'dd/MM/yyyy'" name="start-date" v-model="startDate" :disabled="true"
                                        style="width: 100%;"></datepicker>
                        </div>

                        <div class="my-8">
                            <small class="date-label required">{{ this.$t('workShiftByDay.startTime') }}</small>
                            <!--                            <v-select :value="startHourString" :clearable="false" :options="timeSpans"-->
                            <!--                                      v-validate="'required'" @input="startHour => updateStartHour(startHour)"/>-->
                            <flat-pickr class="w-full" :config="configdateTimePicker" v-model="startHour"
                                        v-validate="'required'" placeholder="Bắt đầu"/>
                        </div>

                        <div class="my-8">
                            <small class="date-label required">{{ this.$t('workShiftByDay.endTime') }}</small>
                            <!--                            <v-select :value="endHourString" :clearable="false" :options="timeSpans"-->
                            <!--                                      v-validate="'required'" @input="endHour => updateEndHour(endHour)"/>-->
                            <flat-pickr class="w-full" :config="configdateTimePicker" v-model="endHour"
                                        v-validate="'required'" placeholder="Kết thúc"/>
                        </div>

                        <div class="my-5">
                            <vs-checkbox v-model="advanceSetting" @input=" checked=> showAdvanceSetting(checked)">
                                {{ this.$t('workShiftByDay.settingAdvance') }}
                            </vs-checkbox>
                        </div>

                        <div v-if="advanceSetting">
                            <div class="my-8">
                                <small class="date-label required">{{ this.$t('workShiftByDay.endInNextDay') }}</small>
                                <v-select :value="endInNextDayString" :clearable="false"
                                          :options="endInNextDayOptions" v-validate="'required'"
                                          @input="endInNextDay => updateEndInNextDay(endInNextDay)"/>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{ this.$t('workShiftByDay.flexible') }}</small>
                                <vs-input class="w-full" v-model="bufferTime" name="bufferTime"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('bufferTime') }}</span>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{ this.$t('workShiftByDay.allowAdvance') }}</small>
<!--                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="allowCheckInBefore"-->
<!--                                            v-validate="'required'"/>-->
                                <vs-input class="w-full" v-model="allowCheckInBefore" name="allowCheckInBefore"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('allowCheckInBefore') }}</span>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{ this.$t('workShiftByDay.allowInlater') }}</small>
<!--                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="allowCheckInAfter"-->
<!--                                            v-validate="'required'"/>-->
                                <vs-input class="w-full" v-model="allowCheckInAfter" name="allowCheckInAfter"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('allowCheckInAfter') }}</span>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{this.$t('workShiftByDay.allowCheckOutIn')}}</small>
<!--                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="allowCheckOutBefore"-->
<!--                                            v-validate="'required'"/>-->
                                <vs-input class="w-full" v-model="allowCheckOutBefore" name="allowCheckOutBefore"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('allowCheckOutBefore') }}</span>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{this.$t('workShiftByDay.allowCheckOutLater')}}</small>
<!--                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="allowCheckOutAfter"-->
<!--                                            v-validate="'required'"/>-->
                                <vs-input class="w-full" v-model="allowCheckOutAfter" name="allowCheckOutAfter"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('allowCheckOutAfter') }}</span>
                            </div>

                        </div>
                    </div>
                </vs-prompt>

                <!-- EDIT EVENT -->
                <vs-prompt
                    class="calendar-event-dialog"
                    :title="this.$t('workShiftByDay.infoShift')"
                    :accept-text="this.$t('button.edit')"
                    :cancel-text="this.$t('button.delete')"
                    @accept="editEvent"
                    @cancel="removeEvent"
                    :is-valid="validForm"
                    :active.sync="activePromptEditEvent">

                    <div class="content-popup">

                        <div class="my-8">
                            <small class="date-label required">{{ $t('workShiftByDay.title') }}</small>
                            <vs-input name="event-name" v-validate="'required'" class="w-full" readonly
                                      v-model="title"></vs-input>
                        </div>

                        <div class="my-8">
                            <small class="date-label required">{{ $t('workShiftByDay.groupShift') }}</small>
                            <vs-input name="group-name" v-validate="'required'" :maxlength="50" class="w-full"
                                      :disabled="disabledFrom"
                                      v-model="groupName"></vs-input>
                        </div>
                        <div class="my-8">
                            <small class="date-label required">{{ $t('workShiftByDay.nameShift') }}</small>
                            <vs-input name="work-shift-name" v-validate="'required'" :maxlength="50" class="w-full"
                                      :disabled="disabledFrom"
                                      v-model="workShiftName"></vs-input>
                        </div>
                        <div class="my-8">
                            <small class="date-label required">{{ this.$t('workShiftByDay.workDay') }}</small>
                            <datepicker :format="'dd/MM/yyyy'" name="start-date" v-model="startDate" :disabled="true"
                                        style="width: 100%;"></datepicker>
                        </div>

                        <div class="my-8">
                            <small class="date-label required">{{ this.$t('workShiftByDay.startTime') }}</small>
                            <!--                            <v-select :value="startHourString" :clearable="false" :options="timeSpans"-->
                            <!--                                      v-validate="'required'" @input="startHour => updateStartHour(startHour)"/>-->
                            <flat-pickr class="w-full" :config="configdateTimePicker" v-model="startHour"
                                        v-validate="'required'" placeholder="Bắt đầu"/>
                        </div>

                        <div class="my-8">
                            <small class="date-label required">{{ this.$t('workShiftByDay.endTime') }}</small>
                            <!--                            <v-select :value="endHourString" :clearable="false" :options="timeSpans"-->
                            <!--                                      v-validate="'required'" @input="endHour => updateEndHour(endHour)"/>-->
                            <flat-pickr class="w-full" :config="configdateTimePicker" v-model="endHour"
                                        v-validate="'required'" placeholder="Kết thúc"/>
                        </div>

                        <div class="my-5">
                            <vs-checkbox v-model="advanceSetting" @input=" checked=> showAdvanceSetting(checked)">
                                {{ this.$t('workShiftByDay.settingAdvance') }}
                            </vs-checkbox>
                        </div>

                        <div v-if="advanceSetting">
                            <div class="my-8">
                                <small class="date-label required">{{ this.$t('workShiftByDay.endInNextDay') }}</small>
                                <v-select :value="endInNextDayString" :clearable="false"
                                          :options="endInNextDayOptions" v-validate="'required'"
                                          @input="endInNextDay => updateEndInNextDay(endInNextDay)"/>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{ this.$t('workShiftByDay.flexible') }}</small>
                                <vs-input class="w-full" v-model="bufferTime" name="bufferTime"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('bufferTime') }}</span>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{ this.$t('workShiftByDay.allowAdvance') }}</small>
                                <!--                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="allowCheckInBefore"-->
                                <!--                                            v-validate="'required'"/>-->
                                <vs-input class="w-full" v-model="allowCheckInBefore" name="allowCheckInBefore"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('allowCheckInBefore') }}</span>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{ this.$t('workShiftByDay.allowInlater') }}</small>
                                <!--                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="allowCheckInAfter"-->
                                <!--                                            v-validate="'required'"/>-->
                                <vs-input class="w-full" v-model="allowCheckInAfter" name="allowCheckInAfter"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('allowCheckInAfter') }}</span>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{this.$t('workShiftByDay.allowCheckOutIn')}}</small>
                                <!--                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="allowCheckOutBefore"-->
                                <!--                                            v-validate="'required'"/>-->
                                <vs-input class="w-full" v-model="allowCheckOutBefore" name="allowCheckOutBefore"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('allowCheckOutBefore') }}</span>
                            </div>

                            <div class="my-8">
                                <small class="date-label required">{{this.$t('workShiftByDay.allowCheckOutLater')}}</small>
                                <!--                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="allowCheckOutAfter"-->
                                <!--                                            v-validate="'required'"/>-->
                                <vs-input class="w-full" v-model="allowCheckOutAfter" name="allowCheckOutAfter"
                                          v-validate="'required|numeric'"/>
                                <span class="text-danger text-sm">{{ errors.first('allowCheckOutAfter') }}</span>
                            </div>

                        </div>
                    </div>

                </vs-prompt>


                <!-- Save & Reset Button -->
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
                            <!--<vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{`${isUpdate ?-->
                            <!--'Cập nhật': 'Tạo mới'}`}}-->
                            <!--</vs-button>-->
                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="employeeList">
                                {{ $t('button.back') }}
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';
import moduleCalendar from '../../../../store/calendar/moduleCalendar.js';
import {CalendarView} from "vue-simple-calendar"
import {vi} from "vuejs-datepicker/src/locale";
import moment from 'moment';
import utils from "../../../../components/utils";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

require("vue-simple-calendar/static/css/default.css");


export default {
    components: {
        vSelect,
        Datepicker,
        CalendarView,
        flatPickr
    },
    data() {
        return {


            configdateTimePicker: {
                enableTime: true,
                dateFormat: 'H:i',
                time_24hr: true,
                noCalendar: true,
            },

            timeSpans: [],
            employeeInfo: {},
            events: [],
            endInNextDayOptions: [
                {value: 0, label: 'Không'},
                {value: 1, label: 'Có'},
            ],

            showDate: null,
            showDateString: null,

            disabledFrom: false,
            id: 0,
            title: '',
            startDate: '',
            endDate: '',
            groupName: '',
            workShiftName: '',
            // endHourString: '',
            endHour: 0,
            // startHourString: '',
            startHour: 0,
            bufferTime: 0,
            allowCheckInBefore: 0,
            allowCheckInAfter: 0,
            allowCheckOutBefore: 0,
            allowCheckOutAfter: 0,
            endInNextDay: 0,

            // allowCheckInBeforeString: '',
            // allowCheckInAfterString: '',
            // allowCheckOutBeforeString: '',
            // allowCheckOutAfterString: '',
            endInNextDayString: '',

            advanceSetting: false,

            langVi: vi,
            calendarView: 'month',

            activePromptAddEvent: false,
            activePromptEditEvent: false,

            calendarViewTypes: [
                {
                    label: "Tháng",
                    val: "month"
                },
                {
                    label: "Tuần",
                    val: "week"
                }
            ]
        }
    },
    created() {
        this.showDate = (moment(new Date()).format('YYYY-MM-DD'));
        this.showDateString = moment(this.showDate).format('DD/MM/YYYY');
        let employeeId = this.$route.query.id;

        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({value: i, label: utils.minuteToHour(i)});
        }
        this.timeSpans = timeSpans;

        if (employeeId) {
            setTimeout(() => {
                this.$vs.loading();
                this.$crm.post('/employee/find-by-id/' + employeeId).then((response) => {
                    this.$vs.loading.close();

                    this.employeeInfo = response.data;
                    this.loadEvents();
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            }, 0);


        }

        //load time

        this.$store.registerModule('calendar', moduleCalendar);
        this.$store.dispatch("calendar/fetchEvents");
        this.$store.dispatch("calendar/fetchEventLabels");

    },
    beforeDestroy() {
        this.$store.unregisterModule('calendar')
    },
    computed: {
        // simpleCalendarEvents() {
        //     return this.events;
        // },
        validForm() {
            let form1 = this.groupName !== ''
                && this.workShiftName !== ''
                && this.startHour !== null
                && this.endHour !== null
                // && this.startHourString !== ''
                // && this.endHourString !== ''
                && !this.disabledFrom
                && (((this.startHour > this.endHour) && this.endInNextDay === 1) || (this.startHour < this.endHour));
            if (this.advanceSetting) {
                return form1
                    && !isNaN(this.bufferTime)
                    && this.allowCheckInAfter !== null
                    // && this.allowCheckInAfterString !== ''
                    && this.allowCheckInBefore !== null
                    // && this.allowCheckInBeforeString !== ''
                    && this.allowCheckOutAfter !== null
                    // && this.allowCheckOutAfterString !== ''
                    && this.allowCheckOutBefore !== null
                    // && this.allowCheckOutBeforeString !== ''
                    && this.endInNextDay !== null
                    && this.endInNextDayString !== '';
            }
            return form1;
        },
        // disabledDatesTo() {
        //     return {to: new Date(this.startDate)}
        // },
        // disabledDatesFrom() {
        //     return {from: new Date(this.endDate)}
        // },
        // calendarLabels() {
        //     return this.$store.state.calendar.eventLabels
        // },
        windowWidth() {
            return this.$store.state.windowWidth
        }
    },

    methods: {
        updateEndInNextDay(item) {
            this.endInNextDayString = item.label;
            this.endInNextDay = item.value;
        },

        employeeList() {
            this.$router.push(`/user/manage-work-shift-by-day${this.employeeInfo.organizationBranchId ? `?branch_id=${this.employeeInfo.organizationBranchId}` : ''}`).catch(() => {
            })
        },
        addEvent() {
            const objPost = {
                "advanceSetting": this.advanceSetting,
                "allowCheckInAfter": this.allowCheckInAfter,
                "allowCheckInBefore": this.allowCheckInBefore,
                "allowCheckOutAfter": this.allowCheckOutAfter,
                "allowCheckOutBefore": this.allowCheckOutBefore,
                "bufferTime": this.bufferTime,
                "employeeId": this.$route.query.id,
                "groupName": this.groupName,
                "organizationBranchId": this.$route.query.branch_id,
                "workDate": this.startDate.toISOString(),
                "startTime": this.startHour ? this.convertHourToMinutes(this.startHour) : null,
                "workShiftName": this.workShiftName,
                "endTime": this.endHour ? this.convertHourToMinutes(this.endHour) : null,
                "endInNextDay": this.endInNextDay
            };

            this.$vs.loading();
            this.$crm.post('/employee-workshift-by-day/create', objPost).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: "Thêm mới ca làm việc thành công",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                });
                this.loadEvents();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showAdvanceSetting(checked) {
            this.advanceSetting = checked;
        },
        updateMonth(val) {
            this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
            this.showDateString = moment(this.showDate).format('DD/MM/YYYY');
            this.events = [];
            this.$vs.loading();
            let start = new Date();
            start.setDate(start.getDate() - 30);
            let end = new Date();
            end.setDate(end.getDate() + 30);
            this.$crm.get(`employee-workshift-by-day/find-all?employeeId=${this.$route.query.id}&start=${start.toISOString()}&end=${end.toISOString()}`).then((response) => {
                this.$vs.loading.close();
                this.employeeInfo = {
                    advanceSetting: response.data.advanceSetting,
                    allowCheckInAfter: response.data.allowCheckInAfter,
                    allowCheckInBefore: response.data.allowCheckInBefore,
                    allowCheckOutAfter: response.data.allowCheckOutAfter,
                    allowCheckOutBefore: response.data.allowCheckOutBefore,
                    bufferTime: response.data.bufferTime,
                    default_BUFFER_TIME: response.data.default_BUFFER_TIME,
                    employeeId: response.data.employeeId,
                    endTime: response.data.endTime,
                    groupName: response.data.groupName,
                    id: response.data.id,
                    organizationBranchId: response.data.organizationBranchId,
                    startTime: response.data.startTime,
                    workDate: response.data.workDate,
                    workEndAt: response.data.workEndAt,
                    workShiftName: response.data.workShiftName,
                    workStartAt: response.data.workStartAt,
                    employeeCode: this.employeeInfo.employeeCode,
                    fullName: this.employeeInfo.fullName,
                    endInNextDay: response.data.endInNextDay,
                }
                response.data.forEach(v => {
                    this.events.push({
                        id: v.id,
                        title: v.workShiftName,
                        startDate: new Date(v.workStartAt),
                        endDate: new Date(v.workEndAt)
                    })
                });
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });

        },
        clearFields() {
            this.title = this.endDate = "";
            this.id = 0;
            this.groupName = '';
            this.workShiftName = '';
            this.startHour = 0;
            this.endHour = 0;
            this.bufferTime = 0;

            this.endHour = 0;
            this.startHour = 0;

            this.allowCheckInBefore = 0;
            this.allowCheckInAfter = 0;
            this.allowCheckOutBefore = 0;
            this.allowCheckOutAfter = 0;
            this.endInNextDay = 0;

            this.advanceSetting = false;
            this.endInNextDayString = '';
        },
        promptAddNewEvent(date) {
            this.addNewEventDialog(date);
        },
        addNewEventDialog(date) {
            this.clearFields();
            this.startDate = date;
            this.endDate = date;
            this.activePromptAddEvent = true;
            this.disabledFrom = false;
        },
        openAddNewEvent(date) {
            if (moment(new Date(date)).format('YYYY-MM-DD') >= moment(new Date()).format('YYYY-MM-DD')) {
                this.addNewEventDialog(date);
            }
        },
        openEditEvent(event) {
            this.disabledFrom = true;
            const e = event;

            if (new Date(new Date(e.startDate).setHours(0,0,0,0)).getTime() >= new Date(new Date().setHours(0,0,0,0)).getTime()) {
                this.disabledFrom = false;
            }

            this.id = e.id;
            this.title = e.title;
            this.startDate = e.startDate;
            this.endDate = e.endDate;
            this.groupName = e.originalEvent.extendedProps.groupName;
            this.workShiftName = e.originalEvent.extendedProps.workShiftName;

            this.startHour = e.originalEvent.extendedProps.startHour;
            this.endHour = e.originalEvent.extendedProps.endHour;

            this.bufferTime = e.originalEvent.extendedProps.bufferTime;
            this.advanceSetting = e.originalEvent.extendedProps.advanceSetting;
            this.allowCheckInAfter = e.originalEvent.extendedProps.allowCheckInAfter;
            this.allowCheckInBefore = e.originalEvent.extendedProps.allowCheckInBefore;
            this.allowCheckOutAfter = e.originalEvent.extendedProps.allowCheckOutAfter;
            this.allowCheckOutBefore = e.originalEvent.extendedProps.allowCheckOutBefore;
            this.endInNextDay = e.originalEvent.extendedProps.endInNextDay;
            this.endInNextDayString = e.originalEvent.extendedProps.endInNextDayString;
            this.activePromptEditEvent = true;
        },
        editEvent() {
            let workDate = new Date(this.startDate.getTime());
            workDate.setHours(0, 0, 0, 0);
            const objPost = {
                "id": this.id,
                "advanceSetting": this.advanceSetting,
                "allowCheckInAfter": this.allowCheckInAfter,
                "allowCheckInBefore": this.allowCheckInBefore,
                "allowCheckOutAfter": this.allowCheckOutAfter,
                "allowCheckOutBefore": this.allowCheckOutBefore,
                "bufferTime": this.bufferTime,
                "employeeId": this.$route.query.id,
                "groupName": this.groupName,
                "organizationBranchId": this.$route.query.branch_id,
                "workDate": workDate.toISOString(),
                "startTime": this.startHour ? this.convertHourToMinutes(this.startHour) : null,
                "workShiftName": this.workShiftName,
                "endTime": this.endHour ? this.convertHourToMinutes(this.endHour) : null,
                "endInNextDay": this.endInNextDay
            };

            this.$vs.loading();
            this.$crm.post('/employee-workshift-by-day/update', objPost).then(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: "Cập nhật ca làm việc thành công",
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success'
                });
                this.loadEvents();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        removeEvent() {
            if (this.startDate.getTime() < new Date().getTime()) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Không thể xóa',
                    text: 'Bạn không thể xóa ngày làm việc cũ hơn ngày hiện tại.'
                })
            } else {
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: `Xác nhận xoá`,
                    text: `Bạn có chắc là muốn xóa ca làm việc này.`,
                    accept: () => {
                        this.$vs.loading();
                        this.$crm.post('/employee-workshift-by-day/delete/' + this.id).then(() => {
                            this.$vs.loading.close();
                            this.$vs.notify({
                                text: "Xóa ca làm việc thành công",
                                iconPack: 'feather',
                                icon: 'icon-check-circle',
                                color: 'success'
                            });
                            this.loadEvents();
                        }).catch((err) => {
                            this.$vs.loading.close();
                            if (err.response.status === 401) {
                                localStorage.clear();
                                return this.$router.push("/pages/login");
                            }
                            return this.$vs.notify({
                                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'danger'
                            });
                        });
                    },
                    acceptText: "Xoá",
                    cancelText: "Huỷ"
                })
            }
        },
        loadEvents() {

            this.$vs.loading();
            let start = new Date();
            start.setDate(start.getDate() - 30);
            let end = new Date();
            end.setDate(end.getDate() + 30);

            this.$crm.get(`employee-workshift-by-day/find-all?employeeId=${this.$route.query.id}&start=${start.toISOString()}&end=${end.toISOString()}`).then((response) => {
                this.$vs.loading.close();
                this.events = [];

                response.data.forEach(v => {
                    this.events.push({
                        id: v.id,
                        title: v.groupName + ' - ' + v.workShiftName,
                        startDate: new Date(v.workStartAt),
                        endDate: new Date(v.workEndAt),
                        extendedProps: {
                            groupName: v.groupName,
                            workShiftName: v.workShiftName,
                            startHour: this.convertMinutesToHour(v.startTime),
                            endHour: this.convertMinutesToHour(v.endTime),
                            bufferTime: v.bufferTime,
                            advanceSetting: v.advanceSetting,
                            allowCheckInAfter: v.allowCheckInAfter - v.startTime,
                            allowCheckInBefore: v.startTime - v.allowCheckInBefore,
                            allowCheckOutAfter: v.allowCheckOutAfter - v.endTime,
                            allowCheckOutBefore: v.endTime - v.allowCheckOutBefore,
                            endInNextDay: v.endInNextDay,
                            endInNextDayString: this.endInNextDayOptions.find(x => x.value === v.endInNextDay).label,
                        }
                    })
                });

            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        convertHourToMinutes(time) {
            let hour = parseInt(time.substr(0, 2));
            let minutes = parseInt(time.substr(3, 2));
            return hour * 60 + minutes;
        },

        convertMinutesToHour(time) {
            let hour = Math.floor(time / 60);
            let minutes = time % 60;
            let resultHour = hour < 10 ? '0' + hour : hour;
            let resulMinutes = minutes < 10 ? '0' + minutes : minutes;
            return `${resultHour}:${resulMinutes}`;
        }
    }
}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>

<style lang="scss">
@import "../../../../assets/scss/vuexy/apps/simple-calendar";


.vs-dialog {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: calc(100% - 20px);
}


.vs-dialog::-webkit-scrollbar {
    width: 0;
}

.vs-dialog-cancel {
    transform: translate(0px, -8px) !important;
}

</style>
